import { CommonModule } from '@angular/common';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { SecurityAndListAutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/security-and-list-autocomplete-in-place/security-and-list-autocomplete-in-place.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import * as i0 from "@angular/core";
export class ReportSecuritySearchInputModule {
}
ReportSecuritySearchInputModule.ɵfac = function ReportSecuritySearchInputModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportSecuritySearchInputModule)(); };
ReportSecuritySearchInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ReportSecuritySearchInputModule });
ReportSecuritySearchInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        CommonModule,
        DisabledModule,
        IconModule,
        SecurityAndListAutocompleteInPlaceModule,
        SecurityListSelectorModalModule,
        TooltipModule] });
